import { Array, Boolean, Null, Number, Optional, Record, Static, String, Union, Unknown } from 'runtypes';

import { ResultDirectionEnum as _ResultDirection } from 'src/models/activity/enums';
import { ActivityExtrasRunType } from 'src/models/activity/extras';
import { AppointmentListExtrasRunType } from 'src/models/appointmentList';
import { ArchivButtonRunType } from 'src/models/archiv';
import { DocumentExtrasRunType } from 'src/models/document/extras';
import { createEnumGuard } from 'src/models/enumGuard';
import { GlobalizationButtonRunType } from 'src/models/globalization';
import { IdoButtonRunType } from 'src/models/ido';
import { MailExtrasRunType } from 'src/models/mail/extras';
import { MessageExtrasRunType } from 'src/models/message/extras';
import { ModuleNameRunType } from 'src/models/module';
import { PhoneCallListExtrasRunType } from 'src/models/phoneCallList/extras';
import { SpoingButtonRunType } from 'src/models/spoing';
import { StatusButtonRunType } from 'src/models/status';
import { TaskButtonRunType } from 'src/models/task';
import { TaskExtrasRunType } from 'src/models/task/extras';
import { GroupedStatusRunType } from 'src/models/taskList/extras';

const ResultDirectionRunType = createEnumGuard(Object.values(_ResultDirection) as _ResultDirection[]);

export const FilterListItemRunType = Record({
	accessRight: Boolean,
	aggregateId: String,
	aggregateVersion: Number,
	archivButton: ArchivButtonRunType,
	archived: Boolean,
	channel: String,
	channelQTip: Null,
	contact: String.Or(Null),
	contactPicture: String.Or(Null),
	contactQTip: String.Or(Null),
	context: String.Or(Null),
	contextQTip: String.Or(Null),
	date: String,
	directAccessUser: String.Or(Null),
	direction: ResultDirectionRunType,
	directionQTip: Null,
	extras: Union(
		AppointmentListExtrasRunType,
		MailExtrasRunType,
		MessageExtrasRunType,
		DocumentExtrasRunType,
		PhoneCallListExtrasRunType,
		TaskExtrasRunType,
		ActivityExtrasRunType
	).Or(Array(Unknown)),
	globalizationButton: GlobalizationButtonRunType,
	globalized: Boolean,
	groupedStatus: Null.Or(GroupedStatusRunType),
	idoButton: IdoButtonRunType,
	idoLinked: Boolean,
	information: String.Or(Null),
	informationQTip: String.Or(Null),
	moduleName: ModuleNameRunType,
	moduleSort: Number.Or(Null),
	processId: String,
	spoingButton: Union(SpoingButtonRunType).Or(Record({})),
	status: Number,
	statusButton: StatusButtonRunType,
	taskButton: Optional(TaskButtonRunType).Or(Null).Or(Unknown),
	timeFrame: Number,
	timestamp: Number,
});

export type FilterListItem = Static<typeof FilterListItemRunType>;
